export default __webpack_public_path__ + "images/R4.27b6cba.png";